import React, { useEffect, useState } from "react";
import MainFooter from '../../components/MainFooter/MainFooter';
import MainHeader from '../../components/MainHeader/MainHeader';
import { Form, TextInput, TextArea } from '@carbon/react';
import { useSnackbar } from 'notistack';
import chatApi from "../../api/chatApi";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import ImgChamp from '../../assets/img/social_link/ImgChamp.svg';


const useRowStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Helvetica Neue',
      fontStyle: 'normal',
      width: '100%',
    },
    // Новый контейнер для двух колонок
    twoColumnContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '90%',
      marginLeft: '5%',
      gap: '40px',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        width: '90%',
        marginLeft: '5%',
      },
    },
    formContainer: {
      flex: '0 0 50%',
      [theme.breakpoints.down('md')]: {
        flex: '1 1 auto',
        width: '100%',
      },
    },
    // Новый стиль для блока с информацией о компании
    companyInfoContainer: {
      flex: '0 0 45%',
      background: '#f4f4f4',
      borderRadius: 8,
      padding: 24,
      boxShadow: '0px 0px 2px rgba(9, 36, 51, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.12)',
      height: 'fit-content',
      [theme.breakpoints.down('md')]: {
        flex: '1 1 auto',
        width: '100%',
        marginTop: 20,
      },
    },
    title: {
      fontFamily: 'Helvetica Neue',
      fontWeight: 400,
      fontSize: 20,
      margin: '30px 0 20px 86px',
      color: 'white',
      [theme.breakpoints.down('xs')]: {
        margin: '30px 10px 20px 20px',
      }
    },
    current: {
      minWidth: 350,
      width: '100%',
      padding: 20,
      boxShadow: '0px 0px 2px rgba(9, 36, 51, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.12)',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginBottom: 50,
      background: 'white',
    },
    customBtn: {
      borderRadius: 4,
      height: 40,
      width: 175,
      maxWidth: 225,
      background: '#0f62fe',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      marginTop: 30,
      '&:hover': {
        background: '#0050e6'
      },
      '@media (max-width: 800px)': {
        width: 225,
      },
    },
    rowInput: {
      marginTop: 10,
    },
    wrapperImg: {
      width: '32%',
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    wrapperText: {
      backgroundColor: 'black',
      flexGrow: 3,
      width: '62%'
    },
    wrapperInfo: {
      display: 'flex',
      width: '100%',
      height: '362px',
      marginTop: 48,
      marginBottom: 20,
    },
    contentContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    footerWrapper: {
      flexShrink: 0,
    },
    // Стили для информации о компании
    companyName: {
      fontSize: 24,
      fontWeight: 600,
      marginBottom: 20,
      color: '#0f62fe',
      borderBottom: '2px solid #0f62fe',
      paddingBottom: 10,
    },
    infoSection: {
      marginBottom: 24,
    },
    infoTitle: {
      fontSize: 18,
      fontWeight: 600,
      marginBottom: 12,
      color: '#161616',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    infoText: {
      fontSize: 14,
      lineHeight: 1.6,
      color: '#525252',
      marginBottom: 8,
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 12,
      fontSize: 14,
      color: '#525252',
    },
    contactIcon: {
      width: 20,
      height: 20,
      color: '#0f62fe',
    },
    workingHours: {
      background: '#e8e8e8',
      padding: 12,
      borderRadius: 6,
      marginTop: 16,
    },
    socialLinks: {
      display: 'flex',
      gap: 16,
      marginTop: 20,
    },
    socialLink: {
      cursor: 'pointer',
      transition: 'opacity 0.2s',
      '&:hover': {
        opacity: 0.7,
      },
    },
  })
)

interface FeedbackFormState {
  text: string;
  topic: string;
  email: string;
}

const Connection: React.FC = () => {
  const [formState, setFormState] = useState<FeedbackFormState>({
    text: '',
    topic: '',
    email: '',
  });
  const classes = useRowStyles()
  const { enqueueSnackbar } = useSnackbar();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { text, topic, email } = formState;

    if (!text.trim() || !topic.trim() || !email.trim()) {
      enqueueSnackbar('Пожалуйста, заполните все поля', { variant: 'error' });
      return;
    }
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar('Пожалуйста, введите корректный email', { variant: 'error' });
      return;
    }
    try {
      const response = await chatApi.sendUsersFeedback(text, topic, email);
      console.log('response', response);

      if (response.success === true) {
        enqueueSnackbar('Форма успешно отправлена!', { variant: 'success' });
        setFormState({ text: '', topic: '', email: '' });
      }
    } catch (error) {
      enqueueSnackbar(`Не удалось отправить форму: ${error.message}`, { variant: 'error' });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MainHeader showComponentHelpFilled={false} />
      <div className={classes.mainContainer}>
        <div className={classes.contentContainer}>
          <div className={classes.wrapperInfo}>
            <div className={classes.wrapperText}>
              <h1 className={classes.title}>Если у Вас остались вопросы, свяжитесь с нами, заполнив форму ниже</h1>
            </div>
            <div className={classes.wrapperImg}>
              <img className={classes.img} src={ImgChamp} alt='img' />
            </div>
          </div>
          
          {/* Новый блок с двумя колонками */}
          <div className={classes.twoColumnContainer}>
            {/* Колонка с формой */}
            <div className={classes.formContainer}>
              <Form onSubmit={handleSubmit} className={classes.current} noValidate>
                <Tooltip title='' placement="top">
                  <div>
                    <TextInput
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Введите ваш email"
                      value={formState.email}
                      onChange={handleInputChange}
                      required
                      className={classes.rowInput}
                      labelText={undefined} />
                    <TextInput
                      id="topic"
                      name="topic"
                      placeholder="Тема сообщения"
                      value={formState.topic}
                      onChange={handleInputChange}
                      required
                      className={classes.rowInput}
                      labelText={undefined} />
                    <TextArea
                      id="text"
                      name="text"
                      placeholder="Введите Ваше сообщение"
                      value={formState.text}
                      onChange={handleInputChange}
                      required
                      className={classes.rowInput}
                      labelText={undefined}
                    />
                  </div>
                </Tooltip>
                <button type="submit" className={classes.customBtn}>
                  Отправить
                </button>
              </Form>
            </div>

            {/* Новая колонка с информацией о компании */}
            <div className={classes.companyInfoContainer}>
              <div className={classes.companyName}>О компании</div>
              
              <div className={classes.infoSection}>
                <div className={classes.infoTitle}>
                  <span>🏢</span> ООО "С.К.А.Т."
                </div>
              </div>

              <div className={classes.infoSection}>
                <div className={classes.infoTitle}>
                  <span>📍</span> Контакты
                </div>
                <div className={classes.contactItem}>
                  <span>📞</span> +7 (495) 123-45-67
                </div>
                <div className={classes.contactItem}>
                  <span>✉️</span> info@skat-vending.com
                </div>
              </div>

              <div className={classes.infoSection}>
                <div className={classes.infoTitle}>
                  <span>🏛️</span> Адрес
                </div>
                <div className={classes.infoText}>
                  г. Краснодар, 350000, ул. Карасунская, 8
                </div>
              </div>

              <div className={classes.socialLinks}>
                <div className={classes.socialLink}>
                  <span>📘 Facebook</span>
                </div>
                <div className={classes.socialLink}>
                  <span>📸 Instagram</span>
                </div>
                <div className={classes.socialLink}>
                  <span>💬 Telegram</span>
                </div>
                <div className={classes.socialLink}>
                  <span>🎥 YouTube</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={classes.footerWrapper}>
          <MainFooter />
        </div>
      </div>
    </div>
  );
};

export default Connection;